import { render, staticRenderFns } from "./DeleteRoleDialog.vue?vue&type=template&id=5eaff27f&scoped=true&"
import script from "./DeleteRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteRoleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaff27f",
  null
  
)

export default component.exports